import fr from 'vuetify/src/locale/fr.ts';

export default {
  $vuetify: {
    ...fr, //needed to handle $vuetify.noDataText value
    OPERATOR: 'Opérateur',
    OPERATORANDWALLET: 'Opérateur / le portefeuille',
    MOBILENUMBER: 'Numéro de portable',
    COUNTRYREQUIRED: 'Pays requis',
    OPERATORREQUIRED: 'Opérateur requis',
    MOBILENUMBERREQUIRED: 'Numéro de portable requis',
    PINCODE: 'code de vérification',
    PINCODEREQUIRED: 'Code PIN requis',
    RESENDPIN: 'Renvoyer le code PIN',
    ALREADYSUBSCRIBEDERR: 'Vous êtes déjà abonné à',
    TERMSOFUSE: "Conditions d'utilisation",
    COUNTRY: 'Pays',
    INVALIDPINCODE: 'Code Pin Invalide',
    REJECTEDSUBSCRIPTION: 'Abonnement refusé par le marchand',
    ALREADYSUBSCRIBED: 'Cet utilisateur est déjà abonné au produit donné',
    GENERALERRORMESSAGE: `Une erreur s'est produite, veuillez réessayer plus tard`,
    PINCODESENTSUCCESS: `Le code PIN a été envoyé sur votre mobile, veuillez vérifier à nouveau!`,
    PAYBYMOBILE: 'Payez par mobile',
    CODESENTTO: 'Code envoyé à ',
    EXPIREDPINCODE: 'Code PIN expiré',
    RESENDTRIALSEXCEEDED: 'Vous avez dépassé le nombre de renvoyer le code PIN',
    INVALIDTRIALSEXCEEDED: `Dépasser le nombre maximal de tentatives atteint d'un code PIN non valide`,
    INVALIDMSISDN: `Veuillez saisir un numéro de téléphone valide pour l'opérateur mobile sélectionné.`,
    INVALIDNUMBER: 'Veuillez saisir un {mobile_label} valide.',
    GENERALFAILUREMESSAGE: `Nous ne pouvions pas charger pour le moment. Veuillez réessayer plus tard`,
    RESPONSECODE_1: "Échec de l'envoi du code PIN, veuillez réessayer",
    RESPONSECODE_2: 'La transaction a été annulée',
    RESPONSECODE_4: "Vous n'avez pas assez de crédit",
    RESPONSECODE_5: `La valeur du paiement dépasse la valeur maximale autorisée par transaction`,
    RESPONSECODE_9: "Une erreur s'est produite, veuillez réessayer plus tard",
    RESPONSECODE_11: 'Code Pin Invalide, veuillez réessayer',
    RESPONSECODE_19: `Votre demande a expiré, veuillez réessayer d'acheter le produit`,
    RESPONSECODE_22: `Veuillez saisir un numéro de téléphone valide pour l'opérateur mobile sélectionné.`,
    RESPONSECODE_14: `Ce service n'est pas disponible pour votre compte, veuillez contacter le service client`,
    RESPONSECODE_16: 'Code PIN expiré, veuillez réessayer',
    RESPONSECODE_51: "Une erreur s'est produite, veuillez réessayer plus tard",
    RESPONSECODE_101: `le portefeuille est facturé, mais n'a pas réussi à contacter le marchand`,
    RESPONSECODE_102: `l'achat ne peut pas être effectué, parce qu'on a detecté une activité suspecte`,
    RESPONSECODE_103: `Votre session expire`,
    RESPONSECODE_104: `Ce numéro de mobile est blacklisté`,
    RESPONSECODE_105: `Sorry, you cannot use the billing service before consuming at least 200 SAR of your balance in other Mobily services.  `,
    RESPONSECODE_202: `La transaction est en cours de traitement`,

    FirstName: 'prénom',
    LastName: 'Nom de famille',
    Email: 'Email',
    AccountNumber: 'Numéro de compte',
    requiredInput: 'Champs requis',
    invalidInputFormat: 'Format invalide',
    UNAUTHORIZEDUSER: 'Utilisateur non autorisé',
    EXPIREDSESSION_TITLE: 'Session expirée',
    EXPIREDSESSION_MSG: 'Votre session a expiré. Veuillez retourner chez le commerçant pour recommencer.',

    VATINCLUDED: 'TVA Inclus',
    VATEXCLUDED: 'TVA Exclu',
    PVATINCLUDED: 'La TVA de {percent}% est inclus dans le prix',
    PVATEXCLUDED: 'La TVA de {percent}% est exclu du prix',

    FREETRIALCONSUMED: `Vous serez abonné au service directement sans une periode d' essai gratuit car vous l'avez déjà pris.`,
    PLAN: 'plan',
    DAYSFREETRIAL: "jours d'essai gratuit !",
    FRAUDTOOLERRORMSG: `l'achat ne peut pas être effectué, parce qu'on a detecté une activité suspecte`,
    MOBILENUMBER_TOO_SHORT_VALIDITY: '{mobile_label} est si court.',
    PINCODE_DIGITS_ONLY: `Le code PIN doit être composé uniquement de chiffres.`,
    UNSUBSCRIBE_ERROR_MSG: `Vous n'êtes pas abonné au {plan_name}`,
    PINCODENOTSENT: 'Le code PIN non envoyé',
    PINCODE_LIMITS: 'Le code PIN doit comprendre entre 4 et 6 chiffres.',

    OPERATOR_VALIDATION_ALERT: `L'opérateur sélectionné est {operator} {country}.`,
    ENTER_MOBILE_MSG: 'Entrez votre numéro de portable {operator}',
    TermsCheckbox_MSG: `J'ai lu tous les termes et conditions faisant partie de l'ensemble de l'arrangement contractuel entre Etisalat et le Client et je les accepte.`,
    ENTER_PINCODEWITHLENGTH_MSG:
      'Veuillez saisir le code de vérification à {pincodeLength} chiffres envoyé sur votre numéro de mobile {mobileNumber}',
    ENTER_PINCODE_MSG:
      'Veuillez entrer le code de vérification envoyé à votre numéro de mobile {mobileNumber}',
    ChangeNumber: 'changer de numéro',
    didnotReceiveCodeLbl: "Vous n'avez pas reçu de code?",
    ResendPinCodeIn: 'Renvoyer dans ',
    static_error_title: 'Erreur',
    static_success_title: 'Félicitation',
    static_pending_title: 'En attente',
    static_error_body:
      'Veuillez réessayer en utilisant le même lien que vous avez reçu.',
    static_success_body: `Votre abonnement a été ré-authentifié avec succès. Veuillez utiliser les mêmes informations d'identification que vous avez reçues précédemment pour accéder au service`,
    static_pending_body: `Votre demande est en cours de traitement. veuillez vérifier après un certain temps. vous pouvez utiliser les mêmes informations d'identification que vous avez reçues précédemment pour accéder au service.`,
  },
};
